module.exports = __webpack_public_path__ + "static/Loja2-9aa076e47bc082a810bc5a55d83a4e26.svg";